var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-button',{staticStyle:{"border-radius":"0"},attrs:{"loading":!_vm.isReady,"disabled":!_vm.isReady,"icon-left":"download","size":"is-large","expanded":""},on:{"click":function($event){return _vm.showModal()}}},[_vm._v("\n  "+_vm._s(_vm.$t('Download'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }